import { Paragraph } from '../../../common/Atoms/Typography/Paragraph';
import { Card } from '../../../common/Atoms/Card';
import { MultiButtonCardHeader } from '../../../common/Atoms/MultiButtonCardHeader';
import { ACTIONS_ARTICLE } from '../../constants/links';
import {
  useForceRecheckAllMutation,
  useRemoveAllFailedActionsMutation,
  useRemovePendingAdhocMutation,
} from '../../services/api/actionApi/action';
import { useGetSelectedOrganisation } from '../../hooks/useGetSelectedOrganisation';
import { CardContent } from '../../../common/Atoms/CardContent';
import { Heading } from '../../../common/Atoms/Typography/Heading';

import { ActionsTable } from './ActionsTable';

export function ActionsTableRoot() {
  const currentOrg = useGetSelectedOrganisation();
  const [recheck, { isLoading: isRechecking }] = useForceRecheckAllMutation();
  const [removeAllActions, { isLoading: isRemovingAllActions }] = useRemoveAllFailedActionsMutation();
  const [removePendingAdhoc, { isLoading: isRemovingPendingAdhoc }] = useRemovePendingAdhocMutation();

  // The controlled state

  function onRecheck() {
    recheck({
      organisationId: currentOrg.id,
    });
  }

  function onRemoveAllActions() {
    removeAllActions({
      organisationId: currentOrg.id,
    });
  }

  function onRemovePendingAdhoc() {
    removePendingAdhoc({
      organisationId: currentOrg.id,
    });
  }

  return (
    <Card>
      <MultiButtonCardHeader
        title={ (
          <Heading>
            { `All Actions ` }
            <Paragraph
              as={ `span` }
              variant={ `link` }>
              <a
                href={ ACTIONS_ARTICLE }
                target={ `_blank` }
                rel={ `noopener noreferrer` }
              >
                { `(How Actions Work)` }
              </a>
            </Paragraph>
          </Heading>
        ) }
        buttons={ [
          {
            buttonText: `Remove scheduled manual actions`,
            onClick: onRemovePendingAdhoc,
            loading: isRemovingPendingAdhoc,
            disabled: isRemovingPendingAdhoc,
            tooltip: `Remove all pending manual actions. This does not undo any actions already completed.`,
          },
          {
            buttonText: `Force recalculate all scheduled actions`,
            onClick: onRecheck,
            loading: isRechecking,
            disabled: isRechecking,
            tooltip: `This will take a few minutes to complete. This happens automatically every 2 hours.`,
          },
          {
            buttonText: `Remove all failed actions`,
            onClick: onRemoveAllActions,
            loading: isRemovingAllActions,
            disabled: isRemovingAllActions,
            tooltip: `This will allow them to be recalulated. If the policy conditions still match.`,
          },
        ] }
        buttonsAsDropdownText={ `Manual Operations` }
        buttonDropdownTheme={ `outline` }
        buttonDropdownSize={ `sm` }
        noDivider
      />
      <CardContent>
        <ActionsTable />
      </CardContent>
    </Card>
  );
}
